module.exports = {
      id: "hamburger--tn-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "images/sprites/ui.svg#hamburger--tn-usage",
      toString: function () {
        return this.url;
      }
    }